import { gql } from "apollo-boost";

const ORDER_EXPIRY = gql`
  mutation orderExpiry($input: OrderExpirySetting) {
    orderExpiry(input: $input) {
      status
      data
      error
    }
  }
`;
export default ORDER_EXPIRY;
